import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../../ui/TextField";
import Checkbox from "../../../../../../../../../ui/Checkbox";
import DataSelect from "../../../../../../../../../ui/DataSelect";
import {getDictPersonPost} from "../../../../../../../../../Dict/store/actions";

const defaultData = {
  firstName: "",
  lastName: "",
  middleName: "",
  email: "",
  phone: "",
  snils: "",
  birthday: "",
  sex: null,
  post: null,
  startDate: "",
  register: false
};

const GENDERS = [
  {
    id: -1,
    name: "не указано"
  },
  {
    id: 0,
    name: "женский"
  },
  {
    id: 1,
    name: "мужской"
  }
];

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  },
  marginTop: {
    marginTop: 13
  }
});

const AddEmployeeForm = ({ disabled, onFormChange, classes,
                           getDictPersonPost, posts}) => {
  const [data, setData] = React.useState(defaultData);

  useEffect(() => {
    getDictPersonPost();
  }, []);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            value={data.lastName}
            onChange={e => onChange("lastName", e.target.value)}
            label="Фамилия"
            disabled={disabled}
            required
          />
          <DataSelect
            value={data.sex}
            onChange={value => onChange("sex", value.id)}
            label="Пол"
            dataSource={GENDERS}
          />
          <TextField
            value={data.phone}
            onChange={e => onChange("phone", e.target.value)}
            label="Телефон"
            disabled={disabled}
          />
          <DataSelect
            disabled={!posts || posts.length < 1}
            value={data.post}
            onChange={value => onChange("post", value._key)}
            label="Должность"
            keyField="_key"
            dataSource={posts}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={data.firstName}
            onChange={e => onChange("firstName", e.target.value)}
            label="Имя"
            disabled={disabled}
            required
          />
          <TextField
            value={data.birthday}
            onChange={e => onChange("birthday", e.target.value)}
            label="Дата рождения"
            disabled={disabled}
            type="date"
          />
          <TextField
            value={data.email}
            onChange={e => onChange("email", e.target.value)}
            label="E-mail"
            disabled={disabled}
            required
          />
          <TextField
            value={data.startDate}
            onChange={e => onChange("startDate", e.target.value)}
            label="Дата регистрации"
            disabled={disabled}
            type="date"
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={data.middleName}
            onChange={e => onChange("middleName", e.target.value)}
            label="Отчество"
            disabled={disabled}
          />
          <TextField
            mask="999-999-999-99"
            maskChar="_"
            value={data.snils}
            onChange={e => onChange("snils", e.target.value)}
            label="Снилс"
            disabled={disabled}
          />
          <Checkbox checked={data.register}
                    label="Отправить приглашение"
                    handleChange={(_, val) => onChange("register", val)}/>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingPosts: state.persons.isFetchingPosts,
  posts: state.dictAll.personPostList
});

const mapDispatchToProps = dispatch => ({
  getDictPersonPost: () => dispatch(getDictPersonPost())
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(AddEmployeeForm));
